<template>
    <v-form ref="form" class="form-container" lazy-validation>

        <v-text-field
            v-model="alias"
            label="Alias"
            class="form-field"
            required
        />

        <v-text-field
            v-model="originator"
            label="Originator"
            :rules="[
                v => !!v || 'Field Required',
                v => (v.length >= 3) || 'Maximum 3 characters allowed',
                v => (v.length <= 11) || 'Maximum 11 characters allowed'
            ]"
            class="form-field"
            required
        />
        <div class="form-wrapper">
            <label class="form-field" for="datepicker">Schedule:</label>
            <date-picker
                id="datepicker"
                v-model="datetime"
                class="form-field"
                type="datetime"
                :disabled-date="getPastDates"
                :disabled-time="getPastTime"
            />
            <v-select
                v-model="excludedSMSCampaignIds"
                label="Excluded Campaigns Select ( Max 3 selected )"
                :menu-props="{ bottom: true, offsetY: true }"
                class="form-field"
                clearable
                persistent-hint
                multiple
                chips
                :items="excludedSMSCampaigns"
                item-text="alias"
                item-value="id"
                @input="limiter"
            />
            <v-file-input
                class="form-field mt-5"
                label="Data File"
                counter
                show-size
                truncate-length="15"
                @change="handleFileUpload"
            />
        </div>
        <create-form-actions needs-padding @cancel="cancel" @next-step="emitNextStep" @reset="reset" />
    </v-form>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import dateTimeUtils from '@/utils/date-time-utils'
    import 'vue2-datepicker/index.css'
    import moment from 'moment'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'
    import smsCampaignService from '@/services/sms-campaign-service'

    export default {
        components: { CreateFormActions, DatePicker },
        data() {
            return {
                originator: '',
                datetime: null,
                imageUrl: '',
                alias: '',
                excludedSMSCampaignIds: '',
                modal: false,
                columnCount: 0,
                uploadedFile: null,
                excludedSMSCampaigns: []
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.originator = ''
                this.datetime = null
                this.imageUrl = ''
                this.excludedSMSCampaignIds = ''
                this.alias = ''
                this.modal = false
                this.columnCount = 0
                document.querySelector('[aria-label="clear icon"]').click()
                this.uploadedFile = null
            })
            this.alias = 'CM_SMS_' + dateTimeUtils.getGreekHumanizedDate(new Date())
            this.datetime = moment().add(2, 'hours').toDate()
            this.fetchExcludedSMSCampaigns()
        },
        methods: {
            handleFileUpload(file) {
                this.uploadedFile = file
                const reader = new FileReader()
                reader.onload = () => {
                    const contents = reader.result
                    this.processCSVData(contents)
                }
                reader.readAsText(file)
            },
            fetchExcludedSMSCampaigns() {
                smsCampaignService.getAllSMSCampaigns({ filter: { completedAtNot: null } }).then(resp => {
                    this.excludedSMSCampaigns = resp.data.content
                })
            },
            processCSVData(contents) {
                this.columnCount = contents
                    .split('\n')[0]
                    .split(',')
                    .filter(entry => /\S/.test(entry))
                    .length
            },
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    originator: this.originator,
                    scheduledAt: dateTimeUtils.getFormattedDateForSubmit(this.datetime),
                    alias: this.alias,
                    params: this.uploadedFile ? this.columnCount - 1 : 5,
                    file: this.uploadedFile
                }
                this.$store.dispatch('setCurrentSMSCampaign', campaign)
                this.$store.dispatch('setCurrentExcludedSMSCampaignIds', this.excludedSMSCampaignIds.toString())
                this.$emit('next-step')
            },
            limiter(e) {
                if (e.length > 3) {
                    e.pop()
                }
            },
            cancel() {
                this.$emit('cancel')
            },
            reset() {
                this.$emit('reset')
            },
            getPastDates(date) {
                return dateTimeUtils.getPastDates(date)
            },
            getPastTime(date) {
                return dateTimeUtils.getPastTime(date)
            }
        }
    }
</script>

<style scoped>

.form-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.form-wrapper {
    width: 100%;
}

</style>
